import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=0b125070&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=0b125070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b125070",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
